import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WxReservationBlacklisTable from '@/types/table/wxReservationBlacklisTable';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WxReservationBlacklisTableData extends WxReservationBlacklisTable {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WxReservationBlacklisTableController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WxReservationBlacklisTableData>>(API_CONTEXT + '/app/wxReservationBlacklisTable/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WxReservationBlacklisTableData>(API_CONTEXT + '/app/wxReservationBlacklisTable/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wxReservationBlacklisTable/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wxReservationBlacklisTable/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wxReservationBlacklisTable/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxReservationBlacklisTable/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxReservationBlacklisTable/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxReservationBlacklisTable/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wxReservationBlacklisTable/deleteBatch', params, httpOptions);
  }
}
